
function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 24)
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 走马灯
    var stringEl = $('.str3').liMarquee({
      loop: -1,
      scrollamount: 100,
    })
    // 初始化
    alignmentFns.initialize()
    // 轮播
    new Swiper('#swiper2', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      slidesPerView: 1.6,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 600)
     $('#2').change(function () {
         var number = Number($('#2').val())
      $(this)
        .parents()
        .parents()
         .siblings('.sp-price')
        .children()
        .children('.new')
        .html(((number * Number(window.product[0].price / 100)).toFixed(2) + '').replace('.', ','))
      $(this)
        .parents()
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.old')
        .html(((number * Number(window.product[0].compare_at_price / 100)).toFixed(2) + '').replace('.', ','))
    })
    $('#3').change(function () {
       var number = Number($('#3').val())
      $(this)
        .parents()
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.new')
        .html(((number * Number(window.product[1].price / 100)).toFixed(2) + '').replace('.', ','))
      $(this)
        .parents()
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.old')
        .html(((number * Number(window.product[1].compare_at_price / 100)).toFixed(2) + '').replace('.', ','))
    })
      $('.link-btn').click(function(){
    let num = $(this).siblings('.sp-number').find('input').val()
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })
    // let prods = window.product
    // console.log(prods,'prods')
    //     function getCur(){
    //     let size = $('#Size div.active').attr('data-val')
    //          // let color = $('#color div.active').attr('data-val')
    //       return prods.filter(item=> item.option1 == size )[0]
    //     }
    //     function changePrice(){
    //       let num = $('#calcNumber').val()
    //       console.log(getCur(),'getCur()')
    //       let price = (getCur().price * num / 100 ).toFixed(2)
    //       let compare = (getCur().compare_at_price * num / 100 ).toFixed(2)
    //          price = (price + '').replace('.', ',')
    //        compare = (compare + '').replace('.', ',')
    //       $('#new').html(price)
    //       $('#old').html(compare)
    //     //    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    //     //   $(".product-part .price3").html(off_font + '% OFF'); 
    //     }

    //   $('.sp-btn-style').click(function(){

    //  window.location.href =
    //     "/cart/" + getCur().id + ":" + $("#calcNumber").val();
    //     })
    // //加减
    // $('.reduce').click(function () {
    //   let input = $(this).siblings('input')[0]
    //   let num = Number(input.value) - 1
    //   if (num > 0) {
    //     input.value = num
    //     changePrice()
    //   }
    // })
    // $('.add').click(function () {
    //   let input = $(this).siblings('input')[0]
    //   let num = Number(input.value) + 1
    //   input.value = num
    //   changePrice()
    // })

    // style选项
    // let typeOptions = $('#color .option')

    // 切换选项
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/c63cfbf6fd040a01ccdc7f711f16cff5.png',
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/c405860a56c8ec77dfe10f93a1c8cd11.png',
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/ef2e56e75f7b98e3dc64cbc244e567f9.png',
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/0ad109224d2c203778fc81f244502b78.png',
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/feaf12866e5c562b000f4c16b5ac7b16.png',
      'https://cdn.shopify.com/s/files/1/0594/6330/3221/files/430c7cae6c80f7489c0575f9eec62405.png'
    ]
    // typeOptions.click(function () {
    //   let index = $(this).index()
    //   let index2 = $('#Size .option.active').index()
    //   $(this).addClass('active').siblings().removeClass('active')
    //   chageimgs(index2, index)
    //   changePrice()
    // })
    $('#Size .option').click(function () {
      let index = $(this).index()
      // let index2 = $('#color .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
       $('.top-product>img').attr('src', imgArr[index])
      changePrice()
    })
    function chageimgs(index, index2) {
      if (index2 == 0) {
        $('.top-product>img').attr('src', imgArr[index])
      } else if (index2 == 1) {
        $('.top-product>img').attr('src', imgArr[index + 2])
      } else if (index2 == 2) {
        $('.top-product>img').attr('src', imgArr[index + 2 * 2])
      }
    }
     // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header .sp-cart").removeClass("on");
      }, 500);
    });
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
    var data = {
          id: getCur().id,
          quantity: $("#calcNumber").val(),
        };

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + "cart.js",
              function (result) {
                $("#cardNum").html(result.item_count);
               
              }
            );
          },
          dataType: "json",
        });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: '946px',
          height: '580px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99999',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 104,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom') +
            10 * $("div#root").css("zoom"),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
